function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Context from "../../services/context";
export default (function () {
  return /*#__PURE__*/React.createElement(Context.Consumer, null, function (_ref) {
    var modal = _ref.modal,
        closeModal = _ref.closeModal,
        args = _objectWithoutProperties(_ref, ["modal", "closeModal"]);

    return modal && /*#__PURE__*/React.createElement(Modal, _extends({
      className: "modal-dialog-centered coreModalContainer",
      isOpen: modal.show,
      toggle: closeModal,
      size: modal.size || 'sm'
    }, modal.props), /*#__PURE__*/React.createElement(ModalHeader, {
      tag: "div",
      className: "coreModalHeader"
    }, modal.title, modal.closeTitle && /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close",
      className: "coreModalClose close",
      "data-dismiss": "modal",
      type: "button",
      onClick: closeModal
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": true
    }, "\xD7"))), /*#__PURE__*/React.createElement(ModalBody, {
      className: "coreModalBody"
    }, modal.content), modal.actions && /*#__PURE__*/React.createElement(ModalFooter, {
      className: "coreModalFooter"
    }, modal.actions));
  });
});